"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCatalogueOfferHandler = addCatalogueOfferHandler;
exports.dispatchAddCatalogueOfferFailedEvent = void 0;
var AddCatalogueOfferFailed = _interopRequireWildcard(require("@ori-events/add-catalogue-offer-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const dispatchAddCatalogueOfferFailedEvent = detail => {
  const event = new CustomEvent(AddCatalogueOfferFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchAddCatalogueOfferFailedEvent = dispatchAddCatalogueOfferFailedEvent;
async function addCatalogueOfferHandler({
  detail: {
    offerId,
    placement
  }
}) {
  const request = await fetch(_types.RequestUrl.AddCatalogueOffer, (0, _utils.getHttpRequestSettings)({
    offerId,
    placement
  }, _checkoutUtils.HttpMethod.Post));
  const response = (0, _utils.convertToCamelCase)(await request.json());
  if (AddCatalogueOfferFailed.isAddCatalogueOfferErrorResponse(response)) {
    dispatchAddCatalogueOfferFailedEvent(response);
    return false;
  }
  return response;
}